export const convertArrayToObject = arr =>
  arr.reduce((acc, curr) => ({ ...acc, [curr]: curr }), {});
